export default defineNuxtPlugin((nuxtApp) => {
    const router = useRouter()
    let scrollToTopOnFinish = false
    let isPopStateNavigation = false

    // Browser Back/Forward fires popstate before Vue Router navigation.
    // Don't force scroll-top in that case — router scrollBehavior restores savedPosition.
    if (import.meta.client) {
        window.addEventListener('popstate', () => {
            isPopStateNavigation = true
        })
    }

    router.beforeEach((to, from) => {
        scrollToTopOnFinish = to.path !== from.path && !to.hash && !isPopStateNavigation
        isPopStateNavigation = false
    })

    nuxtApp.hook('page:finish', () => {
        if (!scrollToTopOnFinish) {
            return
        }

        window.scrollTo({top: 0, left: 0})
        scrollToTopOnFinish = false
    })
})
